import axios from 'axios'

export const bfcDigital = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_BFC_DIGITAL_URL ||
    'https://bfcdigital-api.grupobfc.com.br'
})
